<script setup lang="ts">
import podInit from '@/assets/images/ide/podInit.svg'
import animatingLogo from '@/assets/images/ide/animating_logo.gif'
import { useAdvanceCompilerStore } from '@/stores/advanceCompiler.store'
import { useAdvanceCompilerDatabaseStore } from '@/stores/advanceCompilerDatabase.store'
import { computed, ref, watch } from 'vue'

const props = defineProps({
  isDataBaseRoute: {
    type: Boolean,
    required: false
  }
})

const containerRef = ref<HTMLDivElement | null>(null)

const advanceCompilerStore = useAdvanceCompilerStore()
const advanceCompilerDatabaseStore = useAdvanceCompilerDatabaseStore()

const logMessages = computed(() => {
  return props.isDataBaseRoute
    ? advanceCompilerDatabaseStore.databaseLogMessages
    : advanceCompilerStore.logMessages
})

watch(logMessages, () => {
  if (containerRef.value) {
    if (containerRef.value.scrollHeight > containerRef.value.clientHeight) {
      containerRef.value.scroll({ top: containerRef.value.scrollHeight, behavior: 'smooth' })
    }
  }
})
</script>

<template>
  <div class="flex h-full w-full flex-col gap-x-2 gap-y-6 p-2 lg:flex-row">
    <div class="mx-auto flex h-full lg:w-[45%]">
      <div class="flex w-full flex-col items-center justify-center gap-3">
        <img :src="podInit" class="h-48 w-64" />
        <div>
          <p class="text-base font-semibold text-new-secondary lg:text-lg">
            Preparing your coding playground, please wait...
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <p class="text-xs font-normal leading-[18px] text-new-secondary-500">
            Configuring the engines...
          </p>
          <p class="text-xs font-normal leading-[18px] text-new-secondary-500">
            Resolving dependency issues...
          </p>
          <p class="text-xs font-normal leading-[18px] text-new-secondary-500">
            Calibrating the code editor...
          </p>
        </div>
      </div>
    </div>
    <div class="mx-auto mt-5 h-full lg:w-[55%]">
      <div class="flex w-full flex-col items-start justify-end gap-1 lg:h-2/5">
        <img :src="animatingLogo" class="mx-auto h-24 w-24 text-black sm:mx-0" />
        <p class="flex w-full items-start text-xs font-light leading-[14.40px] text-new-secondary">
          Creating a new machine for you. This may take some time...
        </p>
      </div>
      <div ref="containerRef" class="max-h-80 overflow-auto">
        <div
          class="text-xs font-light text-new-secondary-500"
          v-for="(message, index) in logMessages"
          :key="index"
        >
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>
